export default () => (Math.random()+"").slice(2);